import { render, staticRenderFns } from "./TambahUnit.vue?vue&type=template&id=6cf89caa&scoped=true"
import script from "./TambahUnit.vue?vue&type=script&lang=js"
export * from "./TambahUnit.vue?vue&type=script&lang=js"
import style0 from "./TambahUnit.vue?vue&type=style&index=0&id=6cf89caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf89caa",
  null
  
)

export default component.exports